import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import IMG01 from "../../images/services/ec/Higher-Leads-and-Conversation-Rates.webp";
import IMG02 from "../../images/services/ec/Online-Shopping-Experience.webp";
import IMG03 from "../../images/services/ec/Global-Accessibility.webp";
import IMG04 from "../../images/services/ec/Scalable-and-Growth-Centric.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Technologysec(props) {
    const [activeTab, setActiveTab] = useState(1);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <>
            <div className="tekgriping_section p-100">
                <Container className="h-100">
                    <Row className="h-100">
                        <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                            <div className="example" data-text="Solution">
                                <h2>Real Digital Commerce Transformation</h2>
                            </div>
                            <p>E-commerce apps can transform the decision-making process for businesses and customers
                                alike, by providing access to real-time data and insights that can inform purchasing
                                decisions</p>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <div className="tekgrip_flex">
                                <div className="tekgrip_title">
                                    <h5>274B
                                        <span>Approx. market size</span></h5>
                                </div>
                                <div className="tekgrip_title">
                                    <h5>2.5M
                                        <span>Daily data production</span></h5>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                            <h3 onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                <div className="tab_namee">Higher Leads and Conversation Rates</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                <div className="tab_namee">Online Shopping Experience</div>
                            </h3>

                            <h3 onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                <div className="tab_namee">Global Accessibility</div>
                            </h3>
                            <h3 onClick={() => {
                                displayTab(4)
                            }} className={`tabs ${activeTab === 4 ? 'active' : ''}`}>
                                <div className="tab_namee">Scalable and Growth-Centric</div>
                            </h3>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
                <Container className="h-100">
                    <Row className={activeTab === 1 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Higher Leads and Conversation Rates</h2>
                                <p>Ecommerce applications allow users to complete their purchase cycle all within one
                                    app. Therefore, these online shopping apps help produce quality leads and
                                    significantly improve the conversation rates for a shopping business.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG01}
                                    effect="blur" alt="Migration" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 2 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Online Shopping Experience</h2>
                                <p>TekRevol’s ecommerce apps boost the online shopping experience. With one-touch
                                    functionality and advanced features like omnichannel merchants, and payment data
                                    security, your users can complete their shopping transactions on the go which can
                                    eventually increase sales, improve customer experience, enhance brand awareness, and
                                    provide valuable customer insights.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image">
                                <LazyLoadImage
                                    src={IMG02}
                                    effect="blur" alt="Development" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 3 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Global Accessibility</h2>
                                <p>Intuitive interfaces, easy navigation, functionality, performance, security,
                                    compatibility, aesthetics, support and accessibility are the primary factors that
                                    make any digital product successful in the competitive market. Our applications are
                                    user-centric and developed with target customers in consideration.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG03}
                                    effect="blur" alt="Deployment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className={activeTab === 4 ? 'd-flex h-100' : 'd-none h-100'}>
                        <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_content">
                                <h2>Scalable And Growth-Centric</h2>
                                <p>The ecommerce industry is growing at exponential rates. This means any ecommerce
                                    business opting for mobile solutions now will have to serve a growing number of
                                    shoppers – user profiles from a technical standpoint. Considering this, TekRevol
                                    creates applications with a robust backend and substantial databases to host
                                    thousands of profiles in real-time.</p>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                            <div className="tekgrip_tabs_image ">
                                <LazyLoadImage
                                    src={IMG04}
                                    effect="blur" alt="Deployment" className="img-fluid slide-top"
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default Technologysec;